import { apiFetch } from "./client";
import User from "../dto/User";

export async function getCurrentUser() {
    const response = await apiFetch("/api/users/current");

    if (!response.ok) {
        throw new Error(`Failed to fetch current user (${response.status})`);
    }

    const json = await response.json();

    return new User(json);
}
